import type { MyProfileLedger } from '@/lib/auth';

/**
 * マイプロフィールのタブ定義（表示順）。
 *
 * 各タブは対応する台帳の `self` データスコープが有効な場合のみ表示・アクセス可能とする。
 * プロダクト権限 `my-profile` は廃止され、可視性は台帳 self に連動する
 * （backend はコントローラの宣言的 Guard が台帳 self データスコープで判定する）。`i18nKey` は `common.list` 配下のキー。
 *
 * `ledger` は {@link MyProfileLedger}（`MY_PROFILE_LEDGERS` の要素）に制約する。
 * これにより「マイプロフィールを構成する台帳集合」の SSoT（`@/lib/auth`）と型で結び付き、
 * 対象台帳を増減する際に本定義と入口判定（`canAccessMyProfile`）の齟齬を防ぐ。
 */
export const MY_PROFILE_TABS = [{
  ledger: 'certification',
  to: '/individual/my-profile/education-and-qualification',
  i18nKey: 'educationAndQualification'
}, {
  ledger: 'device',
  to: '/individual/my-profile/devices',
  i18nKey: 'devices'
}, {
  ledger: 'account',
  to: '/individual/my-profile/softwares',
  i18nKey: 'apps'
}] as const satisfies ReadonlyArray<{
  ledger: MyProfileLedger;
  to: string;
  i18nKey: string;
}>;